import {lazy} from "react";
import {Route} from "react-router";
import Error from "@/components/error/error.tsx";

const Stories = lazy(() => import("./features/stories/stories.tsx"));
const Story = lazy(() => import("./features/story/story.tsx"));

const StoriesRoutes= [
    <Route path="/stories" element={<Stories />} errorElement={<Error/>}/>,
    <Route path="/stories/:uuid" element={<Story />} errorElement={<Error/>} />,
];
export default StoriesRoutes;
